import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import { MnNotFoundPageComponent } from './components/not-found-page/not-found-page.component';
// import { MnNoConnectionPageComponent } from './components/no-connection-page/no-connection-page.component';
// import { AuthGuard } from '../session/guards/auth.guard';

const shellRoutes: Routes = [
    // { path: '404', component: MnNotFoundPageComponent, canActivate: [AuthGuard]  },
    // { path: 'no_connection', component: MnNoConnectionPageComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forRoot(shellRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class GaShellRoutingModule { }
